interface ExplanationListProps {
  explanations: string[];
}

export function ExplanationList({ explanations }: ExplanationListProps) {
  if (explanations.length === 0) {
    return <p className="explanation-list__empty">No explanation available for this period.</p>;
  }
  return (
    <ul className="explanation-list">
      {explanations.map((line, i) => (
        <li key={i}>{line}</li>
      ))}
    </ul>
  );
}
